module.exports = __webpack_public_path__ + "img/a-2-net.56651a03.png";